import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";

interface NavigationProps {
  currentIndex: number;
  totalItems: number;
  onChangeIndex: (newIndex: number) => void;
  handlePrev: () => void;
  handleNext: () => void;
  variant?: "light" | "dark";
}

const Navigation: React.FC<NavigationProps> = ({
  currentIndex,
  totalItems,
  onChangeIndex,
  handlePrev,
  handleNext,
  variant = "dark",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempIndex, setTempIndex] = useState<string>(
    (currentIndex + 1).toString()
  );

  useEffect(() => {
    if (!isEditing) {
      setTempIndex((currentIndex + 1).toString());
    }
  }, [currentIndex, isEditing]);

  const handleDoubleClick = () => {
    setTempIndex((currentIndex + 1).toString());
    setIsEditing(true);
  };

  const handleIndexChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTempIndex(e.target.value);
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const parsedIndex = parseInt(tempIndex, 10);
      if (parsedIndex >= 1 && parsedIndex <= totalItems) {
        onChangeIndex(parsedIndex - 1);
      } else {
        alert(`Please enter a number between 1 and ${totalItems}`);
      }
      setIsEditing(false);
    }
  };

  const handleBlur = () => {
    const parsedIndex = parseInt(tempIndex, 10);
    if (!isNaN(parsedIndex) && parsedIndex >= 1 && parsedIndex <= totalItems) {
      onChangeIndex(parsedIndex - 1);
    }
    setIsEditing(false);
  };

  return (
    <div className={`gist-navigation is-${variant}`}>
      <button
        className="gist-navigation-arrow"
        disabled={currentIndex === 0}
        onClick={handlePrev}
        type="button"
      >
        <IoIosArrowDropleft />
      </button>

      <div className="gist-navigation-index">
        {isEditing ? (
          <input
            type="text"
            value={tempIndex}
            onChange={handleIndexChange}
            onKeyDown={handleKeyPress}
            onBlur={handleBlur}
            autoFocus
            className="gist-navigation-input"
          />
        ) : (
          <span onDoubleClick={handleDoubleClick} className="gist-navigation-value">
            {currentIndex + 1}
          </span>
        )}
        <span className="gist-navigation-divider">/</span>
        <span>{totalItems}</span>
      </div>

      <button
        className="gist-navigation-arrow"
        disabled={currentIndex + 1 === totalItems}
        onClick={handleNext}
        type="button"
      >
        <IoIosArrowDropright />
      </button>
    </div>
  );
};

export default Navigation;
